
import { saveEstimate, listEstimate, getEstimateOne, deleteCeSuan, updateEstimate, delNewGroup } from '@/api/enterprise'
import newCenSuan from './newCenSuan'
import newGroup from './newGroup'
import layerContent from './layer-content'
import dayjs from 'dayjs'
import config from '@/config'
export default {
  props: {

  },
  watch: {
  },
  components: {
    newCenSuan,
    newGroup
  },
  data() {
    return {
      layerLoading: false,
      showIndoor: false,
      list: []
    }
  },
  mounted() {
    
  },
  methods: {
    editGroup(da) {
      this.$layer.iframe({
          content: {
            content: newGroup, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
              info:da
            }//props
          },
          maxmin: false,
          time: 0,
          shadeClose: false,
          resize: false,
          scrollbar: false,
          area:['300px','200px'],
          title:"修改分组名",
          cancel: function() {
          }
        });
    },
    delGroup(da) {
        this.$confirm(`您确定删除吗?删除后该分组的所有测算表将消失，不可找回！`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(async () => {
                  // 确定操作                  
                  const res = await delNewGroup({group_id: da.group_id})
                  if (res.code == 0) {
                    this.$toasted.success('操作成功!',{position: "top-center", duration: 2000})
                    this.fetch()
                  }
                }).catch(() => {
        })
    },
    showPop() {
      this.fetch()
      this.showIndoor = true
    },
    hidePop() {
      this.showIndoor = false
    },
    async move(item) {
      const res = await getEstimateOne({id: item.id})
      if (Array.isArray(res.data.estimate_data)) {
          res.data.estimate_data = {}
      }    
      item.estimate_data = res.data.estimate_data 
      this.$layer.iframe({
          content: {
            content: newCenSuan, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
              info: item,
              isEdit: false,
              isMove:  true,
            }//props
          },
          maxmin: false,
          time: 0,
          shadeClose: false,
          resize: false,
          scrollbar: false,
          area:['400px','250px'],
          title:"移动分组",
          cancel: function() {
          }
        });
    },
    async fetch() {
      const res = await listEstimate({});       
      this.list = res.data
      this.active = String(this.list[0].group_id)
    },
    async editNewOne(item) { 
        const res = await getEstimateOne({id: item.id})
        if (Array.isArray(res.data.estimate_data)) {
            res.data.estimate_data = {}
        }    
        item.estimate_data = res.data.estimate_data  
        this.$layer.iframe({
          content: {
            content: newCenSuan, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
              info: item,
              isEdit: true,
              isMove:  false,
            }//props
          },
          maxmin: false,
          time: 0,
          shadeClose: false,
          resize: false,
          scrollbar: false,
          area:['400px','250px'],
          title:"修改测算",
          cancel: function() {
          }
        });
    },
    del(item) {
      this.$confirm(`您确定删除吗?删除后测算表将消失，不可找回！`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(async () => {
                  // 确定操作
                  const res = await deleteCeSuan({id: item.id})
                  if (res.code == 0) {
                    this.$toasted.success('操作成功!',{position: "top-center", duration: 2000})
                    this.fetch()
                  }
                }).catch(() => {
        })
    },
    async exportExcel(item) {
          let that = this  
          this.layerLoading = true        
          const res = await getEstimateOne({id: item.id})
          if (Array.isArray(res.data.estimate_data)) {
            res.data.estimate_data = {}
          }         
          fetch(`${config.SSR_API_URL}/sheet/exportExcel`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({"setCoordinate": res.data.estimate_data})
            }).then(response => {
              if (response.ok) {
                return response.blob();
              } else {
                throw new Error("Error: " + response.statusText);
              }
            }).then(blob => {
              var fileName = `${item.estimate_name}-${dayjs().format('YYYY年MM月DD日 HH时mm分ss秒')}.xlsx`;
              saveAs(blob, fileName);
              that.layerLoading = false
            }).catch(error => {
              that.layerLoading = false
            });
    },
    addNewGroup() {
        this.$layer.iframe({
          content: {
            content: newGroup, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
              info:{a:1}
            }//props
          },
          maxmin: false,
          time: 0,
          shadeClose: false,
          resize: false,
          scrollbar: false,
          area:['300px','200px'],
          title:"新建分组",
          cancel: function() {
          }
        });
    },
    async openCeSuan(item) {
      const res = await getEstimateOne({id: item.id})
      if (Array.isArray(res.data.estimate_data)) {
        res.data.estimate_data = {}
      }            
      this.$layer.iframe({
        content: {
          content: layerContent, //传递的组件对象
          parent: this,//当前的vue对象      
          data:{
            estimate_data: res.data.estimate_data,
            cesuanTitle: item.estimate_name,
            id: item.id,
            group_id: item.group_id
          }//props
        },
        isOutAnim: false,
        maxmin: true,
        time: 0,
        shadeClose: false,
        resize: true,
        scrollbar: false,
        area:['1200px','650px'],
        title: item.estimate_name,
        skin: 'custom-layer-class',
        cancel: function() {
          // 这个函数将在层关闭时调用
          // $('#mapboxglDef').click()
        }
      });
      
      setTimeout( () => {
        $('.vl-notify-content').addClass('custom-layer-class')
      }, 800)
    },
    addNewOne() {
        this.$layer.iframe({
          content: {
            content: newCenSuan, //传递的组件对象
            parent: this,//当前的vue对象      
            data:{
              isEdit: true,
              isMove:  true,
            }//props
          },
          maxmin: false,
          time: 0,
          shadeClose: false,
          resize: false,
          scrollbar: false,
          area:['400px','250px'],
          title:"新建测算",
          cancel: function() {
          }
        });
    }

  },
};
